import ServiceLayout from "@/components/ServiceLayout";
import { QuoteModal } from "@/components/QuoteModal";
import { Button } from "@/components/ui/button";
import { Phone } from "lucide-react";

export default function Neuburg() {
  return (
    <ServiceLayout
      title="Umzugsunternehmen in Neuburg an der Donau"
      description="Ihr lokaler Partner für stressfreie Umzüge, Möbelmontage und Handwerksleistungen direkt in Neuburg an der Donau und Umgebung."
      image="https://images.leadconnectorhq.com/image/f_webp/q_80/r_1200/u_https://assets.cdn.filesafe.space/Zrqvy6cNzSbnzDV55cv1/media/6936df932922ae9c1fe6eaa1.jpg"
      heroBg="https://vibe.filesafe.space/1781514922662573702/assets/1c03dd5e-1d4d-4978-811f-c919569c55a0.png"
      content={
        <>
          <h2 className="font-heading text-3xl md:text-4xl font-bold uppercase tracking-tight">
            Ihr Umzug in Neuburg an der Donau
          </h2>
          <p className="text-lg text-neutral-600">
            Als erfahrenes Umzugsunternehmen kennen wir Neuburg an der Donau und die umliegenden Gebiete sehr gut. Egal ob Sie innerhalb von Neuburg umziehen, neu zuziehen oder die Stadt verlassen – wir sorgen für einen reibungslosen Ablauf.
          </p>
          <p className="text-lg text-neutral-600">
            Wir planen präzise und setzen Ihren Umzug termingerecht um, damit Sie sich entspannt auf Ihr neues Zuhause freuen können.
          </p>
          <ul className="space-y-3 mt-6">
            {[
              "Ortskundige Fahrer & Planer",
              "Einrichtung von Halteverbotszonen",
              "Kurze Anfahrtswege",
              "Kostenlose Besichtigung vor Ort"
            ].map((item, i) => (
              <li key={i} className="flex items-center gap-3 text-neutral-800 font-medium">
                <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center text-primary shrink-0">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                {item}
              </li>
            ))}
          </ul>
        </>
      }
      extendedContent={
        <div className="bg-white">
          <section className="py-16 bg-neutral-50">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Ihr Umzugsunternehmen für Neuburg an der Donau</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Ein Umzug in Neuburg an der Donau muss nicht stressig sein. Als erfahrenes Umzugsunternehmen nehmen wir Ihnen die schwere Arbeit ab und sorgen für einen reibungslosen Ablauf. Egal ob Sie innerhalb der historischen Altstadt umziehen oder in ein neues Viertel ziehen – wir planen Ihren Wohnungswechsel bis ins kleinste Detail.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Mit unserem geschulten Personal und modernen Fahrzeugen garantieren wir einen sicheren und pünktlichen Transport Ihrer Möbel und Kartons. Wir kümmern uns auch um die Einrichtung von Halteverbotszonen, damit am Umzugstag alles perfekt funktioniert.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Kostenloses Angebot anfordern
                      </Button>
                    </QuoteModal>
                    <Button size="lg" variant="secondary" asChild className="w-full sm:w-auto">
                      <a href="tel:+4915888640762">
                        <Phone className="w-5 h-5 mr-2" />
                        +49 15888 640762
                      </a>
                    </Button>
                  </div>
                </div>

                <div className="grid md:grid-cols-2 gap-8 pt-8">
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Privatumzüge in Neuburg</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Wir bieten maßgeschneiderte Lösungen für Ihren Privatumzug. Ob Sie nur Hilfe beim Transport benötigen oder unseren Full-Service-Umzug inklusive Einpackservice nutzen möchten – wir richten uns nach Ihren Wünschen.
                    </p>
                  </div>
                  <div className="bg-white p-8 border border-neutral-200">
                    <h3 className="font-heading text-xl font-bold mb-3">Gewerbliche Umzüge</h3>
                    <p className="text-neutral-600 leading-relaxed">
                      Für Firmen in Neuburg an der Donau bieten wir effiziente Büroumzüge an. Wir minimieren Ihre Ausfallzeiten und transportieren Ihre IT-Infrastruktur und Büromöbel sicher an den neuen Standort.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto space-y-8">
                <div>
                  <h2 className="font-heading text-3xl font-bold mb-4">Umfassende Handwerks- und Montageleistungen</h2>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Wir bieten Ihnen mehr als nur den Transport. Unsere Handwerker übernehmen die professionelle Demontage und Montage Ihrer Möbel. Auch komplexe Schranksysteme und Küchen werden von uns fachgerecht ab- und wieder aufgebaut.
                  </p>
                  <p className="text-neutral-600 leading-relaxed mb-4">
                    Zudem kümmern wir uns um Elektro- und Lichtinstallationen. Wir schließen Ihre Lampen an, installieren Herde und Waschmaschinen und sorgen dafür, dass in Ihrem neuen Zuhause in Neuburg sofort alles funktioniert.
                  </p>
                  <div className="pt-4 pb-2 flex flex-col sm:flex-row items-start gap-4">
                    <QuoteModal>
                      <Button size="lg" className="font-bold text-base px-8 py-6 rounded-none bg-primary text-white hover:bg-primary/90 w-full sm:w-auto">
                        Jetzt beraten lassen
                      </Button>
                    </QuoteModal>
                  </div>
                </div>

                <div className="bg-primary/5 p-8 border-l-4 border-primary mt-8">
                  <h3 className="font-heading text-2xl font-bold mb-3">Transparenz und Sicherheit</h3>
                  <p className="text-neutral-700 leading-relaxed">
                    Nach einer kostenlosen Besichtigung vor Ort in Neuburg erstellen wir Ihnen ein verbindliches Festpreisangebot. So haben Sie die volle Kostenkontrolle. Zudem ist Ihr Umzugsgut während des gesamten Prozesses vollumfänglich versichert.
                  </p>
                </div>
              </div>
            </div>
          </section>

          <section className="py-16 bg-neutral-950 text-white">
            <div className="container mx-auto px-4 md:px-6">
              <div className="max-w-4xl mx-auto text-center">
                <h2 className="font-heading text-3xl font-bold mb-6">Ihre Vorteile in Neuburg an der Donau</h2>
                <div className="grid sm:grid-cols-3 gap-8 mt-12 text-left">
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Regionale Kenntnisse</h3>
                    <p className="text-neutral-400">Wir kennen die Stadt und organisieren Ihren Umzug effizient und ohne Verzögerungen.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Zuverlässigkeit</h3>
                    <p className="text-neutral-400">Pünktlichkeit und Sorgfalt stehen bei uns an erster Stelle – für einen entspannten Umzug.</p>
                  </div>
                  <div>
                    <div className="w-12 h-12 bg-primary flex items-center justify-center mb-4">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path></svg>
                    </div>
                    <h3 className="font-bold text-lg mb-2">Festpreisgarantie</h3>
                    <p className="text-neutral-400">Keine versteckten Kosten dank unserer transparenten und fairen Preisgestaltung.</p>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      }
    />
  );
}
